import '@babylonjs/loaders/glTF';
import './GLTFLoaderWorkerConfig';

import { AbstractMesh, CubeTexture, type ISceneLoaderAsyncResult, Scene, SceneLoader, Vector3 } from '@babylonjs/core';
import { BabylonjsModule } from '@modules/babylonjs';
import { Injectable, Zed } from '@modules/core';
import { World } from 'miniplex';

import { GraphicAPI } from '../graphic';
import { PerformanceProfiler, RenderManager } from '../manager';
import { onAllModelLoaded } from '../observable';
import { buildSrcUrl, Profile } from '../util';

import { CallbackParameters, LoadOptions, LoadResult, SourceParameter } from './data';
import { AsyncTextureLoader } from './extensions';
import { ZEDExtensionLoaderManager } from './extensions/ZEDExtensionLoaderManager';

type EnvironmentParameter = {
  intensity?: number;
  rotationY?: number;
};

export class EnvironmentLoader implements Injectable {
  static readonly INJECTABLE_TOKEN = Symbol.for('EnvironmentLoader');

  private readonly scene;
  private readonly performanceProfiler;
  constructor({
    [Zed.WORLD_TOKEN]: world,
    [BabylonjsModule.INJECTABLE_TOKEN]: babylonjs,
    [PerformanceProfiler.INJECTABLE_TOKEN]: performanceProfiler,
  }: {
    [Zed.WORLD_TOKEN]: World;
    [BabylonjsModule.INJECTABLE_TOKEN]: BabylonjsModule;
    [PerformanceProfiler.INJECTABLE_TOKEN]: PerformanceProfiler;
  }) {
    this.scene = babylonjs.scene;
    this.performanceProfiler = performanceProfiler;
  }
  public dispose() {}

  public loadEnvironment(scene: Scene, src: string, param?: EnvironmentParameter) {
    Profile.start('Load Environment');

    const envTex = CubeTexture.CreateFromPrefilteredData(buildSrcUrl(src), scene);
    envTex.gammaSpace = false;

    if (param) {
      // if (param.intensity) {
      //   envTex.level = param.intensity;
      // }

      if (param.rotationY) {
        envTex.rotationY = param.rotationY;
      }
    } else {
      envTex.level = 1;
    }

    Profile.end('Load Environment');
    this.performanceProfiler.addCustom('Common', 'Load Environment', Profile.get('Load Environment'));

    return envTex;
  }
  public applyEnvironment(scene: Scene, src: string, param?: EnvironmentParameter) {
    scene.environmentIntensity = param?.intensity ?? 1;
    scene.environmentTexture = this.loadEnvironment(scene, src, param);
  }
}
